<template>
  <div class="vpp-panel">
    <p class="text-body-2 mb-1">
      <span class="font-weight-medium">响应调度分组：</span>{{ dispatchGroup }}
    </p>
    <p class="text-body-2 text-purple-darken-1 mb-4">{{ systemStatus }}</p>
    <p class="text-body-2 mb-2"><span class="font-weight-medium">总响应功率：</span>{{ totalPowerKw }} kW</p>

    <v-card variant="outlined" rounded="lg" class="pa-4 mb-6 chart-card">
      <div class="d-flex align-center justify-space-between mb-2">
        <span class="text-subtitle-2 font-weight-medium">总实际功率 {{ chartTotal }} kW</span>
      </div>
      <div class="chart-area rounded">
        <svg viewBox="0 0 400 80" class="chart-svg" preserveAspectRatio="none">
          <line x1="0" y1="60" x2="400" y2="60" stroke="#43a047" stroke-width="2" />
          <text x="8" y="16" class="axis-lbl">功率(kW)</text>
          <text x="8" y="78" class="axis-lbl">0</text>
        </svg>
        <div class="chart-note text-caption text-amber-darken-2">有计划功率曲线时可以叠加在上面</div>
      </div>
      <div class="d-flex justify-space-between text-caption text-medium-emphasis mt-1 px-1">
        <span v-for="t in timeTicks" :key="t">{{ t }}</span>
      </div>
    </v-card>

    <v-divider class="mb-4" />

    <div class="text-subtitle-2 font-weight-medium mb-3">分路功率</div>
    <div class="d-flex flex-wrap ga-2 mb-4">
      <v-chip
        v-for="el in elinks"
        :key="el.id"
        :variant="activeElink === el.id ? 'flat' : 'outlined'"
        :color="activeElink === el.id ? 'primary' : undefined"
        size="large"
        @click="activeElink = el.id"
      >
        <template #prepend>
          <span class="elink-dot" />
        </template>
        {{ el.label }}
      </v-chip>
    </div>

    <v-card variant="outlined" rounded="lg" class="pa-4 chart-card">
      <div class="text-subtitle-2 font-weight-medium mb-2">实际功率 {{ branchPower }} kW（{{ activeElinkLabel }}）</div>
      <div class="chart-area rounded">
        <svg viewBox="0 0 400 80" class="chart-svg" preserveAspectRatio="none">
          <line x1="0" y1="60" x2="400" y2="60" stroke="#43a047" stroke-width="2" />
        </svg>
      </div>
      <div class="d-flex justify-space-between text-caption text-medium-emphasis mt-1 px-1">
        <span v-for="t in timeTicks" :key="'b' + t">{{ t }}</span>
      </div>
    </v-card>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'

const dispatchGroup = '嘉兴和省电动高速储能电站'
const systemStatus = '[系统处于第三方控制中]'
const totalPowerKw = ref(0)
const chartTotal = ref('0.0')

const timeTicks = ['18:13:00', '18:13:15', '18:13:30', '18:13:45', '18:14:00']

const elinks = [
  { id: '1', label: '1#eLink' },
  { id: '2', label: '2#eLink' },
  { id: '3', label: '3#eLink' },
]
const activeElink = ref('1')
const activeElinkLabel = computed(() => elinks.find((e) => e.id === activeElink.value)?.label ?? '')
const branchPower = ref('0.0')

defineExpose({
  getDraft: () => ({
    mode: 'vpp',
    dispatchGroup,
    activeElink: activeElink.value,
  }),
})
</script>

<style scoped>
.vpp-panel {
  max-width: 900px;
}
.text-purple-darken-1 {
  color: #7b1fa2;
}
.chart-card {
  border-color: #e4e8f0 !important;
}
.chart-area {
  position: relative;
  height: 120px;
  background: linear-gradient(180deg, #fafbfd 0%, #fff 100%);
  border: 1px solid #e8ecf5;
}
.chart-svg {
  width: 100%;
  height: 100%;
}
.axis-lbl {
  fill: rgba(0, 0, 0, 0.45);
  font-size: 10px;
}
.chart-note {
  position: absolute;
  right: 8px;
  top: 8px;
  max-width: 200px;
}
.elink-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #2e7d32;
  margin-right: 6px;
}
</style>
